<template>
  <SportFeaturePlaceholder
    sport-label="Rugby"
    title="Edit Rugby Team"
    description="Rugby team editing is now scaffolded as its own route and will mirror basketball editing workflows."
    primary-cta="Open Rugby Dashboard"
    :primary-route="{ name: 'RugbyTeamDashboard' }"
    :back-route="{ name: 'RugbyTeamDashboard' }"
  />
</template>

<script>
import SportFeaturePlaceholder from "@/routes/match_hub/shared/SportFeaturePlaceholder.vue";
export default { name: "RugbyTeamEdit", components: { SportFeaturePlaceholder } };
</script>
